import { render, staticRenderFns } from "./cost-history.vue?vue&type=template&id=140e7594&scoped=true&"
import script from "./cost-history.vue?vue&type=script&lang=js&"
export * from "./cost-history.vue?vue&type=script&lang=js&"
import style0 from "./cost-history.vue?vue&type=style&index=0&id=140e7594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e7594",
  null
  
)

export default component.exports